import React, { useState } from "react";
import { Star, Heart } from "lucide-react";
import { collection, addDoc } from "firebase/firestore";
import { auth, db } from "./Firebase";
import { useDispatch } from "react-redux";
import { addToCart } from "../Redux/cart/cartSlice";
import { useNavigate } from "react-router-dom";


const ProductCard = ({ card }) => {
  const navigate = useNavigate();
  console.log(card);
  const [liked, setLiked] = useState(false);
  const dispatch = useDispatch();

  const handleAddToCart = (card)=>{
    dispatch(addToCart(card))
  }




  const handleLikeButton = (card) => {
    setLiked((prev) => !prev);
    try {
      auth.onAuthStateChanged(async (user) => {
        const likedProductsRef = collection(db, "LikedCards", user.uid, "products");
        await addDoc(likedProductsRef, {
          card : card
        });
      });
    } catch (error) {
      console.log("Error saving liked card:", error.message);
    }
  };
  const handleFullproduct = (card) => {
    navigate(`/product/${card.id}`, { state: { product: card } });
  };

  const colorMap = {
    gray: "bg-gray-500",
    blue: "bg-blue-800",
    red: "bg-red-600",
    green: "bg-green-500",
    yellow: "bg-yellow-400",
    pink: "bg-pink-400",
    purple: "bg-purple-600",
    teal: "bg-teal-500",
    indigo: "bg-indigo-700",
    orange: "bg-orange-500",
    lime: "bg-lime-400",
    amber: "bg-amber-500",
    cyan: "bg-cyan-500",
    rose: "bg-rose-500",
    fuchsia: "bg-fuchsia-500",
    emerald: "bg-emerald-500",
    sky: "bg-sky-500",
    violet: "bg-violet-600",
    stone: "bg-stone-400",
    neutral: "bg-neutral-300",
    slate: "bg-slate-400",
    zinc: "bg-zinc-400",
  };

  return (
    <div className=" rounded-xl border-gray-500 relative max-w-[320px] bg-slate-50 "  onClick={() => handleFullproduct(card)}>
      <h2 className="absolute bg-red-500 text-white left-[0px] top-[0px] p-1 rounded-tl-xl">
        {" "}
        {card.discount}% off
      </h2>
      <h2
        className="absolute right-5 top-3 bg-white p-2 rounded-full cursor-pointer"
        onClick={() => handleLikeButton(card)}
      >
        <Heart className={liked ? "fill-red-800  text-red-800" : ""} />
      </h2>
      <img
        src={`${card.images[0]}`}
        alt={card.name}
        className="w-[320px] h-[350px] object-cover object-center rounded-t-xl cursor-pointer" 
        onClick={() => handleFullproduct(card)}
      ></img>
      <div className="mt-2 p-1 pb-2 mb-2">
        <div className="flex justify-between mt-2 items-start mb-1">
          <p className="text-xl font-medium justify-start">{card.name}</p>
          <p className="flex flex-col font-bold text-sm items-end ">
            ${card.finalPrice}{" "}
            <span className="ml-2 line-through font-medium text-xs ">
              ${card.price}
            </span>
          </p>
        </div>
        <div className="flex mb-1 text-sm font-medium items-end ">
          <Star className="text-xs" /> {card.ratings}
          <span className="text-orange-400 ml-4 font-medium">
            {card.reviewsCount}+ reviews
          </span>
        </div>
        <div className="flex items-center justify-between gap-2">
          Available colors :
          <div className="flex gap-1">
            {card.colorOptions.map((color, index) => (
              <div
                key={index}
                className={`h-4 w-4 rounded-full border ${
                  colorMap[color] || "bg-gray-300"
                }`}
              ></div>
            ))}
          </div>
        </div>

        <p className="w-[90%]">{card.description}</p>

        <p className="bg-violet-500 text-white text-center p-2 rounded-xl mt-2 cursor-pointer hover:bg-violet-800" onClick={()=>handleAddToCart(card) }>
          Add To Cart
        </p>
      </div>
    </div>
  );
};

export default ProductCard;
